<script setup lang="ts">
import type { Editor } from '@tiptap/vue-3'
import { computed } from 'vue'
import type { PropType } from 'vue'

import clsx from 'clsx'

import { useEditorBetaStore } from '@/stores/editor/beta'

const betaStore = useEditorBetaStore()
const props = defineProps({
    editor: {
        type: Object as PropType<Editor>,
        required: true
    },
    isDark: {
        type: Boolean,
        required: true
    },
    active: {
        type: Boolean as PropType<boolean | null>,
        default: null
    }
})

const isActive = computed(() => {
    return typeof props.active === 'boolean'
        ? props.active
        : props.editor.isActive('underline')
})

const onToggleUnderline = () => {
    betaStore.getTextEditorCommandChain(props.editor)?.toggleUnderline().run()
}
</script>

<template>
    <button
        @click="onToggleUnderline"
        :class="
            clsx(
                'action-underline',
                isDark ? 'dark' : 'light',
                isActive ? 'is-active' : 'is-deactive'
            )
        "
    >
        <span class="sr-only">Underline</span>

        <svg
            class="w-[25px] h-6"
            stroke="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 25 24"
            fill="none"
        >
            <path
                d="M19.5 19H5.5M17.5 6V11C17.5 13.7614 15.2614 16 12.5 16C9.73858 16 7.5 13.7614 7.5 11V6M6 5H9M16 5L19 5"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    </button>
</template>

<style scoped>
.action-underline.light svg {
    @apply stroke-[#060606];
}

.action-underline.dark svg {
    @apply stroke-[#FAFAFA];
}

.action-underline.is-deactive svg {
    @apply opacity-60;
}

.action-underline.is-active svg {
    @apply opacity-100;
}
</style>
